import { render } from "./Header.vue?vue&type=template&id=6a632bb4"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Kelvin Rodriguez\\Desktop\\Projects\\digital_cert_ads_portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__